// eslint-disable-next-line
import styled from 'styled-components';

export const Base = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2x);
  margin-bottom: var(--spacing-4x);
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2x);
`;

export const StructureInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2x);
`;

export const CheckboxGroupLink = styled.a`
  color: var(--color-primary);
  text-decoration: none;
  font-weight: 600;
  margin-left: 4px;

  &:hover {
    text-decoration: underline;
  }
`;
